import React from 'react'
import ReactStars from 'react-stars'
import CommentForm from './comment-form'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

import './view-text.css'
import { deleteCommentFromApi, sendEditedCommentToApi } from '../actions/comments'
import { getEditsFromApi } from '../actions/text'

export class ViewText extends React.Component {
	constructor(props) {
		super(props)

		this.commentRefs = []
		this.controlRefs = []
		this.submitRefs = []

		this.showEditControls = this.showEditControls.bind(this)
		this.deleteComment = this.deleteComment.bind(this)
		this.editComment = this.editComment.bind(this)
	}

	componentDidMount() {
		const id = this.props.location.state.textId
		this.props.dispatch(getEditsFromApi(id))
	}

	deleteComment(i, commentId, textId, e) {
		e.preventDefault()
		this.props.dispatch(deleteCommentFromApi(commentId, textId, false))
	}

	showEditControls(i, e) {
		e.preventDefault()
		this.submitRefs[i].classList.toggle('hide')
		this.controlRefs[i].classList.toggle('hide')
	}

	editComment(commentId, textId, i, e) {
		e.preventDefault()
		this.props.dispatch(sendEditedCommentToApi(commentId, textId, this.commentRefs[i].value, false))

		this.submitRefs[i].classList.toggle('hide')
		this.controlRefs[i].classList.toggle('hide')
	}

	render() {
		if(!this.props.loggedIn) {
			return <Redirect to='/' />
		}

		const textData = this.props.recentTexts.filter(text => text._id === this.props.location.state.textId)[0]

		if(!textData) {
			return <Redirect to={ {
						pathname: '/404/not-found',
						state: { filename: this.props.location.state.textId }
					} } />
		}

		const comments = textData.comments.length ? 
			textData.comments.map((comment, i) => {
				const edit = comment.uid === this.props.uid ?
					<div className='edit-controls' id={ comment._id }>
						<div  ref={ input => this.controlRefs[i] = input }>
							<button className='x-button' onClick={ e => this.deleteComment(i, comment._id, textData._id, e) }>x</button>
							<button className='comment' onClick={ e => this.showEditControls(i, e) }>Edit</button>
						</div>
						<div ref={ input => this.submitRefs[i] = input } className='hide'>
							<textarea className='edit-comment' ref={ input => this.commentRefs[i] = input } defaultValue={ comment.body }/>
							<button className='comment' onClick={ e => this.showEditControls(i, e) }>Done</button>
							<button className='comment' onClick={ e => this.editComment(comment._id, textData._id, i, e) }>Submit</button>
						</div>
					</div>
					: <div></div>

				return (
					<div className='comments' key={ comment._id }>
						<Link to={{
							pathname: `/user/${comment.uid}`,
							state: { userId: comment.uid }
						}}>{ comment.author }</Link>
						<div className='comment-body'>{ comment.body }</div>
						<ReactStars 
							className='comment-stars'
							name={`comment-${ i }`}
							color1='#7103a0'
							color2='#4fff7b'
							count={ 5 }
							value={ comment.rating }
							size={ 12 }
							edit={ false }
						/>
						{ edit }
					</div>
				)
			}) 
		: <div></div>

		const textEdits = this.props.textEdits
		let editList
        textEdits.length ? editList = textEdits.map((edit, i) => {
                return <div key={ i }>
                        	<Link to={ {
                        	    pathname: `/edited/${ edit.title }`,
                        	    state: { editId: edit._id }
                        	} }>{ edit.title }</Link> edited by <Link to={ {
                        		pathname: `/user/${ edit.editorId }`,
                        		state: { userId: edit.editorId }
                        	} }>{ edit.editorName }</Link>
                        </div>
                })
            : editList = <div className='no-edits'>No edits of this post exist yet.</div>

		return(
			<div className='row'>
				<div className='view-text col-12'>
					<div className='text col-8'>
						<Link to={{
							pathname: `/edit/${ textData.title }`,
							state: {
								text: textData
							}
						}}>Edit this paper</Link>
						<div className='text-body'>
							<h2>{ textData.title } by <Link to={ {
									pathname: `/user/${ textData.authorId }`,
									state: { userId: textData.authorId }
								} }>{ textData.authorName }
								</Link>
							</h2>
							<p>{ textData.body }</p>
						</div>
					</div>
					<div className='text-info'>
						<div className='edit-list col-3'>Edits: { editList }</div>
						<div className='comment-container col-3'>Comments:{ comments }</div>
						<CommentForm item={ textData._id } isEdit={ false }/>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	loggedIn: state.auth.uid !== null,
	textEdits: state.text.textEdits,
	uid: state.auth.uid,
	recentTexts: state.text.recentTexts
})

export default connect(mapStateToProps)(ViewText)


// WEBPACK FOOTER //
// ./src/components/view-text.js